import React from "react";

import type { Product } from "resources/types";

import { Teaser } from "./teaser";
import { TeaserFooter } from "./teaser-footer";
import { PlayButton } from "./play-button";

interface Props {
  product: Product;
  colorless?: boolean;
  className?: string;
  onClick?: () => void;
  index?: number;
}

export function PricelessTeaser({ product, colorless, className, onClick, index }: Props) {
  const [isPlayMounted, setIsPlayMounted] = React.useState(false);

  const handlePlayButton = () => {
    setIsPlayMounted(true);
  };

  return (
    <Teaser.Container colorless={colorless} className={className} onMouseEnter={handlePlayButton}>
      <Teaser.Link onClick={onClick} product={product} index={index}>
        <Teaser.Cover alt={product.name} url={product.image_url} />
        <Teaser.Title title={product.name} />
        <Teaser.Author author={product.description} />
        <TeaserFooter.CycleOrRatingBadge product={product} />
        <TeaserFooter.ClubBadge product={product} />
      </Teaser.Link>
      {isPlayMounted && <PlayButton product={product} />}
    </Teaser.Container>
  );
}
